import { Component, computed, OnDestroy, OnInit, Signal, inject } from '@angular/core';
import {
  BaseCreatePasswordComponent,
  ErrorDetail,
  Params,
} from '../../../../shared/components/create-password/create-password.component';
import { PasswordResetService } from '../../../../_services/password-reset/password-reset.service';
import { BoFormsModule } from '@bo/ng-forms';
import { PasswordFieldComponent } from '../../../../shared/components/forms/password-field/password-field.component';
import { SubmitComponent } from '../../../../shared/components/forms/submit/submit.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterSwitchBtnComponent } from '../../../../shared/components/router-switch-btn/router-switch-btn.component';
import { Observable } from 'rxjs';
import { CodeValidate, PasswordData, PasswordResponse } from '../../../../_interfaces/password-interface';
import { Method } from '@bo/ng-api';
import { ProgressBarService } from '../../../../_services/progress-bar-service/progress-bar.service';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-create-password',
  imports: [BoFormsModule, PasswordFieldComponent, SubmitComponent, RouterSwitchBtnComponent, LoaderComponent],
  templateUrl: '../../../../shared/components/create-password/create-password.component.html',
})
export class CreatePasswordForgotPasswordComponent
  extends BaseCreatePasswordComponent<PasswordResponse>
  implements OnInit, OnDestroy
{
  readonly passwordService = inject(PasswordResetService);
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);
  readonly progressBarService = inject(ProgressBarService);
  override readonly store: Store;

  override formLabel: string = 'forgotPassword';
  override resend$ = undefined;
  override invalidDetail: ErrorDetail = {
    title: 'It seems like your link has expired.',
    text: ['If you are having trouble remembering your password, please reset your password.'],
  };
  override notFoundDetail: ErrorDetail = {
    title: "We couldn't find your account",
    text: ['Please proceed to the login page to try again.'],
  };

  readonly params: Signal<Params> = computed(() => {
    const queryParams = this.route.snapshot.queryParams;
    return {
      code: queryParams['token'] as string,
      id: queryParams['user_id'] as string,
    };
  });

  constructor() {
    const store = inject(Store);
    super();
    this.store = store;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    const data: CodeValidate = { code: this.params().code, user_id: this.params().id };
    this.passwordService.validateCode(data).subscribe(this.validateResponseHandler());
    this.progressBarService.setHideProgress(true); // Set to true to hide the progress bar
  }

  override createForm(): void {
    this.buildFromOptions(
      this.passwordService.getOptions(this.passwordService.URL_PASSWORD_RESET + '/', Method.POST),
    ).subscribe();
  }

  override submitData(formData: PasswordData): Observable<PasswordResponse> {
    formData.user_id = this.params().id;
    formData.code = this.params().code;
    return this.passwordService.resetPassword(formData);
  }

  override handleSubmitSuccess(): void {
    this.router.navigate(['/login']);
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.progressBarService.setHideProgress(false); // Set to false to show the progress bar
  }
}
